import { Flex, theme } from "antd";

const CardTitle = ({ title, size = "lg", icon, tools, tools_font_size = "md" }) => {
  const {
    token: { fontSize, fontSizeLG, fontSizeXL },
  } = theme.useToken();

  const sizeToFontSizeMap = {
    md: fontSize,
    lg: fontSizeLG,
    xl: fontSizeXL,
  };

  return (
    <Flex 
      justify="space-between"
      style={{
        marginTop: "-0.5rem",
        marginBottom: "1rem",
        fontWeight: 600,
        fontSize: sizeToFontSizeMap[size],
      }}
    >
      <Flex gap="small">
        {title}
        {icon}
      </Flex>
      <Flex 
        style={{
          color: "grey", 
          fontWeight: "normal", 
          fontSize: sizeToFontSizeMap[tools_font_size]
        }}
      >
        {tools}
      </Flex>
    </Flex>
    
  );
};

export default CardTitle;
